import React, {useContext, useEffect, useState} from "react";
import {Modal, Table} from "antd";
import {useRequest} from "ahooks";
import {ColumnsType} from "antd/es/table/index";
import moment from "moment";
import {apiGetSchBatch} from "@/services/exam_signup";
import {DetailContext} from "@/context/detailContext";
import {TSchList} from "@/types/exam";

type TBatchListModal = {
  visible: boolean;
  onClose:() => void;
  title: string;
}

const BatchListModal:React.FC<TBatchListModal> = ({title,visible, onClose}) => {
  const contextProps = useContext(DetailContext);
  const {data} = contextProps;
  const {cert_id, type} = data;
  const [list, setList] = useState<TSchList[]>([]);
  const {runAsync} = useRequest(() => {
    return apiGetSchBatch(cert_id);
  }, {
    manual: true,
    onSuccess:(res) => {
      if (res.code === 200){
        setList(res.data)
      }
    }
  })

  const columns: ColumnsType<TSchList> = [
    {
      title: '考试期数',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '考试开始时间',
      dataIndex: 'startTime',
      key: 'startTime',
      render:(_,record) => {
        return <span>{moment(record.startTime).format('YYYY-MM-DD HH:mm:ss')}</span>
      }
    },
    {
      title: '考试结束时间',
      dataIndex: 'endTime',
      key: 'endTime',
      render:(_,record) => {
        return <span>{moment(record.endTime).format('YYYY-MM-DD HH:mm:ss')}</span>
      }
    },
  ];
  useEffect(() => {
    if (['fcrp','fcbp','fcjp','fcap'].includes(type) && visible){
      runAsync();
    }
  }, [type, visible]);
  return (
    <Modal centered footer={null} visible={visible} onCancel={onClose} title={`${title}-考试安排`}>
      <Table columns={columns} dataSource={list}/>
    </Modal>
  )
}
export default BatchListModal;
